/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Undefined
 *
 * 1 = FullMainDealer
 *
 * 2 = Full
 *
 * 3 = Part
 *
 * 4 = No
 */
export enum ServiceHistory {
  Undefined = 0,
  FullMainDealer = 1,
  Full = 2,
  Part = 3,
  No = 4,
}
